import {
  FETCH_INVOICE_PREFIXES_ATTEMPT,
  FETCH_INVOICE_PREFIXES_SUCCESS,
  FETCH_INVOICE_PREFIXES_ERROR,
  FETCH_INVOICE_PREFIX_ATTEMPT,
  FETCH_INVOICE_PREFIX_SUCCESS,
  FETCH_INVOICE_PREFIX_ERROR,
  CREATE_INVOICE_PREFIX_ATTEMPT,
  CREATE_INVOICE_PREFIX_SUCCESS,
  CREATE_INVOICE_PREFIX_ERROR,
  CREATE_INVOICE_PREFIX_RESET_STATE,
  UPDATE_INVOICE_PREFIX_ATTEMPT,
  UPDATE_INVOICE_PREFIX_SUCCESS,
  UPDATE_INVOICE_PREFIX_ERROR,
  UPDATE_INVOICE_PREFIX_RESET_STATE,
  DELETE_INVOICE_PREFIX_ATTEMPT,
  DELETE_INVOICE_PREFIX_SUCCESS,
  DELETE_INVOICE_PREFIX_ERROR,
  DELETE_INVOICE_PREFIX_RESET_STATE,
} from "../../actionTypes/actionTypes";
import invoicePrefixesService from "../../../apis/services/admin/invoicePrefixesService";

export const fetchInvoicePrefixes = (page = 1, perPage = 20, isActive = null, search = "", sortBy = "id", order = "DESC") => {
  return async (dispatch) => {
    dispatch({ type: FETCH_INVOICE_PREFIXES_ATTEMPT });
    try {
      const response = await invoicePrefixesService.getInvoicePrefixes(page, perPage, isActive, search, sortBy, order);
      dispatch({
        type: FETCH_INVOICE_PREFIXES_SUCCESS,
        payload: {
          data: response.data?.data || [],
          page: response.data?.page || page,
          perPage: response.data?.perPage || perPage,
          total: response.data?.total || 0,
        },
      });
    } catch (error) {
      dispatch({
        type: FETCH_INVOICE_PREFIXES_ERROR,
        payload: error.response?.data?.message || "Error fetching invoice prefixes",
      });
    }
  };
};

export const fetchInvoicePrefix = (id) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_INVOICE_PREFIX_ATTEMPT });
    try {
      const response = await invoicePrefixesService.getInvoicePrefix(id);
      dispatch({
        type: FETCH_INVOICE_PREFIX_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_INVOICE_PREFIX_ERROR,
        payload: error.response?.data?.message || "Error fetching invoice prefix",
      });
    }
  };
};

export const createInvoicePrefix = (prefixData) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_INVOICE_PREFIX_ATTEMPT });
    try {
      const response = await invoicePrefixesService.createInvoicePrefix(prefixData);
      dispatch({
        type: CREATE_INVOICE_PREFIX_SUCCESS,
        payload: response.data,
      });
      return { success: true, data: response.data };
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error creating invoice prefix";
      dispatch({
        type: CREATE_INVOICE_PREFIX_ERROR,
        payload: errorMessage,
      });
      return { success: false, error: errorMessage };
    }
  };
};

export const updateInvoicePrefix = (id, prefixData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_INVOICE_PREFIX_ATTEMPT });
    try {
      const response = await invoicePrefixesService.updateInvoicePrefix(id, prefixData);
      dispatch({
        type: UPDATE_INVOICE_PREFIX_SUCCESS,
        payload: response.data,
      });
      return { success: true, data: response.data };
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error updating invoice prefix";
      dispatch({
        type: UPDATE_INVOICE_PREFIX_ERROR,
        payload: errorMessage,
      });
      return { success: false, error: errorMessage };
    }
  };
};

export const deleteInvoicePrefix = (id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_INVOICE_PREFIX_ATTEMPT });
    try {
      await invoicePrefixesService.deleteInvoicePrefix(id);
      dispatch({
        type: DELETE_INVOICE_PREFIX_SUCCESS,
        payload: id,
      });
      return { success: true };
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error deleting invoice prefix";
      dispatch({
        type: DELETE_INVOICE_PREFIX_ERROR,
        payload: errorMessage,
      });
      return { success: false, error: errorMessage };
    }
  };
};

export const createInvoicePrefixResetState = () => ({
  type: CREATE_INVOICE_PREFIX_RESET_STATE,
});

export const updateInvoicePrefixResetState = () => ({
  type: UPDATE_INVOICE_PREFIX_RESET_STATE,
});

export const deleteInvoicePrefixResetState = () => ({
  type: DELETE_INVOICE_PREFIX_RESET_STATE,
});

